import { useModalState } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings, getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useEffect } from "react";

import { PageWrapper } from "../components/PageWrapper";
import { Navbar } from "../Navbar";
import { CrossMarketplaceIntroSlide } from "../Onboarding/OnboardingFlowContainer/components/CrossMarketplaceIntroSlide";
import { InstantInterviewSlide } from "../Onboarding/OnboardingFlowContainer/JobsEducationStep/components/InstantInterviewSlide";
import { JobCardsSlide } from "../Onboarding/OnboardingFlowContainer/JobsEducationStep/components/JobCardsSlide";
import { QualificationApprovedSlide } from "../Onboarding/OnboardingFlowContainer/JobsEducationStep/components/QualificationApprovedSlide";
import { UnfamiliarEducationDialog } from "../Onboarding/UnfamiliarMarketplaceEducation/UnfamiliarEducationDialog";
import { useShouldShowUnfamiliarMarketplaceEducation } from "../Onboarding/UnfamiliarMarketplaceEducation/useShouldShowUnfamiliarMarketplaceEducation";
import { PlacementCandidatePage } from "../PlacementCandidate/Page";

export function PlacementsRootPage({ hidden }: { hidden?: boolean }) {
  const worker = useDefinedWorker();
  const { shouldShow: shouldShowUnfamiliarEducation, markAsSeen } =
    useShouldShowUnfamiliarMarketplaceEducation("jobs");
  const educationModalState = useModalState("closed");
  const { openModal } = educationModalState;

  useEffect(() => {
    if (shouldShowUnfamiliarEducation) {
      openModal();
    }
  }, [shouldShowUnfamiliarEducation, openModal]);

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />

      <PageWrapper
        sx={{
          ...(hidden && { display: "none" }),
          ...getSafeAreaPaddings({
            top: true,
          }),
          // hack to force the safe area background color to be the same as the page background color
          backgroundColor: (theme) => theme.palette.background.tertiary,
        }}
      >
        <PlacementCandidatePage worker={worker} />

        <Navbar />
      </PageWrapper>

      {!hidden && educationModalState.modalIsOpen && (
        <UnfamiliarEducationDialog
          modalState={educationModalState}
          analyticsEvent={APP_V2_USER_EVENTS.UNFAMILIAR_JOBS_EDUCATION_VIEWED}
          onComplete={markAsSeen}
        >
          <CrossMarketplaceIntroSlide unfamiliarMarketplace="jobs" />
          <JobCardsSlide />
          <InstantInterviewSlide />
          <QualificationApprovedSlide />
        </UnfamiliarEducationDialog>
      )}
    </ThemeProvider>
  );
}
